Cureus.UserProfileModals = {};

//= require_tree ./UserProfileModals